import { ModalGeneric } from 'ypf-pas-general-ui-components';
import { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';

import {
  updateimputationObjectMSDSApprover,
  updateImputationObjectSDSApprover
} from '../../../../../../services/workReport';
import useToast from '../../../../../../hooks/useToast';
import { ubicationTypeEnum } from '../../../../../../utils/dataStatus';

import ImputationObjectDetailVE from './ImputationObjectDetailVE';

const validationSchema = Yup.object().shape({
  imputationType: Yup.object().required('Seleccione un tipo de imputación'),
  imputationObject: Yup.object().required('Seleccione un objeto de imputación'),
  detailObject: Yup.object().nullable()
});

const ModalImputationObjectVE = ({
  setShowModal,
  showModal,
  title,
  fechaRealizacionDesde,
  fechaRealizacionHasta,
  idsParteDiario,
  nroLinea,
  nroPosicion,
  isMSDS,
  idSolicitud,
  idUbicacion,
  handleReloadTable,
  tipoUbicacionEnum,
  ubicacion
}) => {
  const { setNewToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [disabledActions, setDisabledActions] = useState(false);
  const { values, setFieldValue } = useFormik({
    initialValues: {
      imputationType: {},
      imputationObject: {},
      detailObject: {},
      initialImputationObject: {},
      initialImputationType: {}
    },
    validationSchema
  });
  const formRef = useRef(null);
  const updateData = async () => {
    const validPozoId = (tipoUbicacionEnum === ubicationTypeEnum.pozo ||
      tipoUbicacionEnum === ubicationTypeEnum.locacion) && {
      pozoId: values?.pozoId
    };

    try {
      setLoading(true);
      const nombreObjetoImputacion = values?.imputationObject?.nombre?.split('|')[0];

      if (isMSDS) {
        const body = [
          {
            ubicacion,
            ...(validPozoId || {}),
            sociedad: values?.detailObject?.socCode,
            centro: values?.detailObject?.logisticCenter,
            tipoImputacion: values?.imputationType?.id,
            objetoImputacion: {
              id: values?.imputationObject?.id,
              nombre: nombreObjetoImputacion.trim()
            }
          }
        ];

        await updateimputationObjectMSDSApprover({ idSolicitud, idUbicacion }, body);
      } else {
        const body = {
          objetosImputacion: [
            {
              ...(validPozoId || {}),
              ubicacion,
              tipoImputacionId: values?.imputationType?.id,
              objetoImputacion: {
                id: values?.imputationObject?.id,
                nombre: nombreObjetoImputacion.trim()
              }
            }
          ]
        };

        await updateImputationObjectSDSApprover(idSolicitud, body);
      }
      setNewToast({
        type: 'SUCCESS',
        message: 'Se ha actualizado correctamente'
      });
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error?.message
      });
    } finally {
      setLoading(false);
      setShowModal(false);
      handleReloadTable();
    }
  };

  useEffect(() => {
    if (
      Object.keys(values?.imputationObject).length === 0 ||
      Object.keys(values?.imputationType).length === 0
    ) {
      setDisabledActions(true);

      return;
    }

    if (
      values?.initialImputationObject?.id === values?.imputationObject?.id &&
      values?.initialImputationType?.id === values?.imputationType?.id
    ) {
      setDisabledActions(true);

      return;
    }
    setDisabledActions(false);
  }, [values]);

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={async () => setShowModal(false)}
      primaryAction={updateData}
      primaryActionDisabled={disabledActions}
      primaryActionLabel="Aceptar"
      secondaryAction={() => setShowModal(false)}
      secondaryActionLabel="Salir"
      show={showModal}
      size="xl"
      title="Detalles del tipo y objeto de imputación"
    >
      <ImputationObjectDetailVE
        fechaRealizacionDesde={fechaRealizacionDesde}
        fechaRealizacionHasta={fechaRealizacionHasta}
        form={formRef}
        idsParteDiario={idsParteDiario}
        loading={loading}
        nroLinea={nroLinea}
        nroPosicion={nroPosicion}
        setFieldValue={setFieldValue}
        setLoading={setLoading}
        showModal={showModal}
        title={title}
        values={values}
      />
    </ModalGeneric>
  );
};

export default ModalImputationObjectVE;

ModalImputationObjectVE.propTypes = {
  setShowModal: PropTypes.func,
  showModal: PropTypes.bool,
  fechaRealizacionDesde: PropTypes.string.isRequired,
  fechaRealizacionHasta: PropTypes.string.isRequired,
  idsParteDiario: PropTypes.arrayOf(PropTypes.number).isRequired,
  nroLinea: PropTypes.number.isRequired,
  nroPosicion: PropTypes.number.isRequired,
  isMSDS: PropTypes.bool.isRequired,
  idSolicitud: PropTypes.number.isRequired,
  idUbicacion: PropTypes.number.isRequired,
  handleReloadTable: PropTypes.func.isRequired,
  title: PropTypes.string,
  tipoUbicacionEnum: PropTypes.number.isRequired,
  ubicacion: PropTypes.string.isRequired
};

ModalImputationObjectVE.defaultProps = {
  setShowModal: () => {},
  showModal: false,
  title: ''
};
